import { Heart } from 'lucide-react'
import { CheckInIcon } from './CheckInIcon'
import { GoingCheckIcon } from './GoingCheckIcon'
import { cn } from '../lib/utils'

/** The set dialog's status glyph: checked in, going, or a heart filled when interested. */
export function SetInterestIcon({ status, checkedIn, idleClassName }: {
  status: 'interested' | 'going' | null
  checkedIn: boolean
  idleClassName: string
}) {
  if (status === 'going') return checkedIn ? <CheckInIcon className="size-6" /> : <GoingCheckIcon className="size-6" />
  return <Heart className={cn('size-6', status === 'interested' ? 'fill-interested text-interested' : idleClassName)} />
}
